import geolocator from "geolocator";

import utils from "../helpers/utils";

// A token that identifies a location. A dirty solution for identifying a location without additional relation table
// const getLocationToken = location => {
//     const latitude = location.lat || location.position.lat;
//     const longitude = location.long || location.position.lng;
//     const radius = location.RadiusInMeters || location.radius;
//     const isAvailableArea = typeof location.isAvailableArea === 'boolean' ? location.isAvailableArea : location.availability.state;
//     const address = location.Address || location.address;
//
//     return String(latitude) + String(longitude) + String(radius) + String(isAvailableArea) + address
// };

// A token that identifies a location. A dirty solution for identifying a location without additional relation table
const getLocationToken = (
  location,
  excludeFields = ["subjects", "ServiceDistrictsID"]
) => {
  const latitude = excludeFields.includes("latitude")
    ? ""
    : location.lat || location.position.lat;
  const longitude = excludeFields.includes("longitude")
    ? ""
    : location.long || location.position.lng;
  const radius = excludeFields.includes("radius")
    ? ""
    : location.RadiusInMeters || location.radius;
  const isAvailableArea = excludeFields.includes("isAvailableArea")
    ? ""
    : typeof location.isAvailableArea === "boolean"
      ? location.isAvailableArea
      : location.availability.state;
  const address = excludeFields.includes("address")
    ? ""
    : location.Address || location.address;
  const subjects = excludeFields.includes("subjects") ? "" : location.subjects;
  const district = excludeFields.includes("district") ? "" : location.ServiceDistrictsID;

  const fields = {
    latitude,
    longitude,
    radius,
    isAvailableArea,
    address,
    subjects,
    district,
  };

  for (let excludedField of excludeFields) {
    delete fields[excludedField];
  }

  return Object.values(fields).reduce((acc, curr) => acc + String(curr), "");
};

const getGlobalLocations = (subjects, locations) => {
  const _locations = locations.map((l) => ({ ...l, locationToken: getLocationToken(l) }));

  const locationSubjectsMap = _locations.reduce((acc, l) => {
    const locationToken = l.locationToken;

    if (!acc[locationToken]) acc[locationToken] = [];
    acc[locationToken] = [...acc[locationToken], l.ServiceSubjectID];
    return acc;
  }, {});

  const globalLocationsTokens = Object.entries(locationSubjectsMap).reduce(
    (acc, entry) => {
      const [locationToken, subjectsIds] = entry;

      const isGlobal = subjects.every((s) =>
        subjectsIds.find((id) => id === s.SubjectID)
      );

      return isGlobal ? [...acc, locationToken] : acc;
    },
    []
  );

  return globalLocationsTokens.map((token) =>
    _locations.find((l) => l.locationToken === token)
  );
};

const getUniqueLocations = (locations = []) => {
  const _locations = locations.map((l) => ({ ...l, locationToken: getLocationToken(l) }));
  return utils.unique(_locations, "locationToken");
};

const getCityAndCountry = (place) => {
  let city = null;
  let country = null;

  const placeComponentTypesForCity = [
    "locality",
    "postal_town",
    "administrative_area_level_5",
    "administrative_area_level_4",
    "administrative_area_level_3",
    "administrative_area_level_2",
    "administrative_area_level_1",
  ];

  for (let componentType of placeComponentTypesForCity) {
    const component = place.address_components.find((c) =>
      c.types.some((t) => t === componentType)
    );
    if (component) {
      city = component.short_name;
      break;
    }
  }

  const countryComponent = place.address_components.find((c) =>
    c.types.some((t) => t === "country")
  );

  if (countryComponent) {
    country = countryComponent.short_name;
  }

  return { city, country };
};

geolocator.config({
  language: "en",
  google: {
    version: "3",
    key: "AIzaSyDFbswAUbdZbQFeEy-s2oHc-_-dIcCAZPo",
  },
});

const geolocatorOptions = {
  enableHighAccuracy: false,
  timeout: 5000,
  maximumWait: 10000, // max wait time for desired accuracy
  maximumAge: 0, // disable cache
  desiredAccuracy: 1000, // meters
  fallbackToIP: true, // fallback to IP if Geolocation fails or rejected
  addressLookup: true, // requires Google API key if true
  timezone: true, // requires Google API key if true
  // map: "map-canvas",      // interactive map element id (or options object)
  // staticMap: true         // get a static map image URL (boolean or options object)
};

const locate = () =>
  new Promise((resolve, reject) => {
    geolocator.locateByIP(geolocatorOptions, function (err, location) {
      if (err) {
        console.log("Geolocation error: ", err);
        reject(err);
        return;
      }

      resolve(location);
    });
  });

export {
  getGlobalLocations,
  getLocationToken,
  getCityAndCountry,
  getUniqueLocations,
  geolocatorOptions,
  locate,
};
